import { render, staticRenderFns } from "./NumberWithDate.vue?vue&type=template&id=2d185d60"
import script from "./NumberWithDate.vue?vue&type=script&lang=js"
export * from "./NumberWithDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports